import { useTranslation } from 'react-i18next'
import { ForgotPasswordForm } from '@/components/features/auth'

export function ForgotPasswordPage() {
  const { t } = useTranslation('auth')

  return (
    <div className="w-full max-w-md">
      <div className="mb-8 text-center">
        <h1 className="text-2xl font-bold">{t('forgotPasswordTitle')}</h1>
        <p className="text-muted-foreground">{t('forgotPasswordSubtitle')}</p>
      </div>
      <ForgotPasswordForm />
    </div>
  )
}
